import { Box, SxProps } from '@mui/material';
import { IContentWrapperProps } from './interfaces';
import PageSubtitleContent from './PageSubtitleContent/PageSubtitleContent';
import { useStyles } from './styles';

const ContentWrapper = ({
  children,
  subtitle = '',
  text = '',
  forceKeepSubtitle = false,
  sx = {},
}: IContentWrapperProps) => {
  const classes = useStyles();
  const hasContent = subtitle || text;
  const {
    content: contentSx = {},
    container: containerSx = {},
    title: titleSx,
  } = sx;

  return (
    <Box sx={{ ...classes.root, ...containerSx } as SxProps}>
      {hasContent ? (
        <PageSubtitleContent
          subtitle={subtitle}
          text={text}
          forceKeepSubtitle={forceKeepSubtitle}
          sx={titleSx}
        />
      ) : null}
      <Box sx={{ ...contentSx }}>{children}</Box>
    </Box>
  );
};

export default ContentWrapper;
